import { useLayoutEffect, useRef } from "react";
import { composeRefs, useMemoizedFn } from "@exonn/hooks";

export const useRestoreScrollPosition = ({
  onSavePosition,
  getSavedPosition,
}: {
  onSavePosition: ({ top, left }: { top: number; left: number }) => void;
  getSavedPosition: () => {
    top?: number | undefined;
    left?: number | undefined;
  };
}) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const restoreScroll = useMemoizedFn((node: HTMLDivElement | null) => {
    if (node) {
      const position = getSavedPosition();
      if (position.top) {
        node.scrollTop = position.top;
      }
      if (position.left) {
        node.scrollLeft = position.left;
      }
    }
  });

  const scrollEl = scrollContainerRef.current;
  useLayoutEffect(() => {
    if (!scrollEl) {
      return;
    }

    const handleScroll = (e: Event) => {
      const target = e.target as HTMLElement;
      onSavePosition({
        top: target.scrollTop,
        left: target.scrollLeft,
      });
    };
    scrollEl.addEventListener("scroll", handleScroll);
    return () => scrollEl.removeEventListener("scroll", handleScroll);
  }, [scrollEl, onSavePosition]);

  return {
    containerRef: composeRefs(scrollContainerRef, restoreScroll),
  };
};
